import algoliasearch from 'algoliasearch/lite';
import Config from 'utils/getEnvConfig';

const {
  ALGOLIA: { APPLICATION_ID, SEARCH_API_KEY },
} = Config;
const client = algoliasearch(APPLICATION_ID, SEARCH_API_KEY);

export default client;
